import axios from "axios"

const dispatch = (fileToSend)=>
{
const targetUrl="https://httpbin.org/post"
console.log(fileToSend)
axios.post(targetUrl, fileToSend).then((response)=>{console.log(response)
return("success");
}).catch((error)=>
    {
    if(error.response)
        {
         console.log("server responded")
        return("server responded")
        }

    else if(error.request)
        {
        console.log("network error")
        return("network error")
        }

    else 
        {
        console.log("network error")
        return("error")
        }

    })
} 



export default dispatch